import axios from 'axios'

/**
 * 获取我创建的访问密钥对列表
 */
export const getAccessList = async () => {
  const { data } = await axios.get(`v1/access/mine`)
  return data
}

/**
 * 新增访问密钥
 */
export const addAccess = async (options) => {
  let data = await axios.post(`v1/access`, options)
  return data
}

/**
 * 更新访问密钥
 */
export const updateAccess = async (options) => {
  await axios.put(`v1/access/${options.accessId}`, options)
}

/**
 * 删除访问密钥
 */
export const deleteAccess = async (accessId) => {
  let data = await axios.delete(`v1/access/${accessId}`)
  return data
}

/**
 * 停用访问密钥
 */
export const disableAccess = async (accessId) => {
  await axios.post(`v1/access/${accessId}/disable`)
}

/**
 * 启用访问密钥
 */
export const enableAccess = async (accessId) => {
  await axios.post(`v1/access/${accessId}/enable`)
}
